import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  city: 'Buenos Aires'
}, {
  name: 'Carolina S.',
  city: 'Córdoba'
}, {
  name: 'Valentina R.',
  city: 'Rosario'
}, {
  name: 'Luciana M.',
  city: 'Mendoza'
}, {
  name: 'Florencia G.',
  city: 'Tucumán'
}, {
  name: 'Romina P.',
  city: 'Paraná'
}, {
  name: 'Agustina D.',
  city: 'Salta'
}, {
  name: 'Camila T.',
  city: 'Neuquén'
}, {
  name: 'Daniela F.',
  city: 'Posadas'
}, {
  name: 'Sofía B.',
  city: 'Resistencia'
}, {
  name: 'Antonella V.',
  city: 'La Plata'
}, {
  name: 'Belén O.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta C.',
  city: 'San Juan'
}, {
  name: 'Micaela H.',
  city: 'Bariloche'
}, {
  name: 'Paula E.',
  city: 'Santiago del Estero'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 2;
}
function getRandomIndex(exclude: number) {
  let next = Math.floor(Math.random() * PURCHASES.length);
  while (next === exclude && PURCHASES.length > 1) {
    next = Math.floor(Math.random() * PURCHASES.length);
  }
  return next;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(() => Math.floor(Math.random() * PURCHASES.length));
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    // First popup appears after 4s
    const initial = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initial);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Show for 4s
    const hide = setTimeout(() => {
      setVisible(false);
      // Show next after 3s gap → total cycle ~ 7s
      const showNext = setTimeout(() => {
        setCurrentIndex(prev => getRandomIndex(prev));
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, 3000);
      return () => clearTimeout(showNext);
    }, 4000);
    return () => clearTimeout(hide);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-[60] max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-278">
      <div className="bg-[#faf3e3] border border-[#2d3f2a]/15 rounded-xl p-3.5 shadow-lg" data-id="element-279">
        <div className="flex items-start gap-3" data-id="element-280">
          <div className="w-9 h-9 rounded-full bg-[#5a6b3f]/15 border border-[#5a6b3f]/30 flex items-center justify-center flex-shrink-0" data-id="element-281">
            <span className="text-sm" data-id="element-282">✨</span>
          </div>
          <div className="min-w-0" data-id="element-283">
            <p className="text-[#1e3a1e] text-sm font-semibold leading-tight" data-id="element-284">
              {purchase.name}
              <span className="text-[#5a5040] font-normal" data-id="element-285"> de </span>
              <span className="text-[#b8860b]" data-id="element-286">{purchase.city}</span>
            </p>
            <p className="text-[#3a4a35] text-xs mt-0.5" data-id="element-287">
              adquirió la{' '}
              <span className="text-[#1e3a1e] font-semibold" data-id="element-288">
                Formación en Biodescodificación
              </span>
            </p>
            <p className="text-[#7a7060] text-[10px] mt-1" data-id="element-289">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}